//사용자 리스트
import React, { useState, useEffect } from "react";
import axios from "@app/lib/axios";

import AgGridReactEx from "@app/components/AgGridReactEx";
import Modal from "react-bootstrap/Modal";
import moment from "moment";

import PaginationV2 from "@app/components/Pagination/V2";

import crypto from "crypto";

import { ta } from "date-fns/locale";

import * as util from "@app/lib/utility";

const basePagingInfo = { perPage: 18, maxShowPage: 10 };

const sortByProperty = (arr, key, dir = "asc") => {
    arr.sort((a, b) => {
        if ((dir == "asc" && a[key] < b[key]) || (dir == "desc" && a[key] > b[key])) {
            return -1;
        } else if ((dir == "asc" && a[key] > b[key]) || (dir == "desc" && a[key] < b[key])) {
            return 1;
        } else {
            return 0;
        }
    });
};

const NurseryDetail = ({isRoleBranch, selectedBranchId, selectedNurseryId, combineAppAuth, serviceAppList }) => {
    const [loadingData, setLoadingData] = useState(true);
    const [show, setShow] = useState(false);
    const [userId, setUserId] = useState(null);
    const [userDetail, setUserDetail] = useState(null);
    const [nurseryInfo, setNurseryInfo] = useState(null);
    const [nurseryBranch, setNurseryBranch] = useState(null);
    const [nurseryUser, setNurseryUser] = useState(null);
    const [nurseryUserTable, setNurseryUserTable] = useState(null);
    const [playddClassList, setPlayDDClassList] = useState([]);
    const [playddDeviceHost, setPlayDDDeviceHost] = useState([]);
    const [playddDeviceClient, setPlayDDDeviceClient] = useState([]);
    const [usingData, setUsingData] = useState(null);
    const [userHistory, setUserHistory] = useState(null);
    const [UsingDataTable, setUsingDataTable] = useState(null);
    const [subKeyword, setSubKeyword] = useState(null);
    const [subKeyword2, setSubKeyword2] = useState(null);
    const [subSearchApp, setSubSearchApp] = useState("all");
    const loginBranchInfo = util.getLoginBranchInfo();

    useEffect(() => {
        if (selectedNurseryId != null) {
            getNurseryData(selectedNurseryId);
            // getUsingData(selectedNurseryId);
        }
        return () => {};
    }, [selectedNurseryId]);

    useEffect(() => {
        if (show) contractHistoryCallback();
        findUser(userId);
        return () => {};
    }, [show]);

    useEffect(() => {
        searchUsingData();
    }, [subSearchApp]);

    useEffect(() => {
        if (nurseryUser) {
            getPlayDDData();
        }
    }, [nurseryUser]);

    useEffect(() => {
        searchUsingData();
    }, [usingData]);

    useEffect(() => {}, [playddClassList, playddDeviceHost, playddDeviceClient]);

    const getNurseryData = (nurseryUniqId) => {
        setLoadingData(true);
        axios({
            method: "POST",
            url: `/api/subscriber/nursery/user/list/${nurseryUniqId}`,
            data: { branchId: selectedBranchId },
        })
            .then((res) => {
                setNurseryInfo(res.data.nurseryInfo);
                setNurseryBranch(res.data.nurseryBranch);
                setLoadingData(false);

                let data = combineAppAuth(res.data.subscriber, null, res.data.appAuth);
                let userDetail = [];
                let userDeviceHistory = [];

                data.map((s) => {
                    var userAllInfo = Object.assign(s);
                    serviceAppList.forEach((a) => {
                        if(a.contractUseTas && a.key != 'playdd') {
                            userAllInfo[`${a.key}_device_cnt`] = 0;
                        }
                    });
                    let userDevices = res.data.userDevices.filter((d) => s.sid == d.sid);
                    if (userDevices && userDevices.length > 0) {
                        userDevices.forEach((d) => {
                            d.user_id = s.user_id;
                            d.class_name = s.class_name;
                            userAllInfo.start_date = d.start_date;
                            userAllInfo.end_date = d.end_date;
                            serviceAppList.forEach((a) => {
                                if(a.key == d.app_id && a.contractUseTas && a.key != 'playdd') {
                                    userAllInfo[`${a.key}_device_cnt`]++;
                                }
                            });
                            userDeviceHistory.push(d);
                        });
                    }

                    userDetail.push(userAllInfo);
                });
                
                setUsingData(userDeviceHistory);
                setUsingDataTable(userDeviceHistory);
                setNurseryUser(userDetail);
                setNurseryUserTable(userDetail);

                if(isRoleBranch) {
                    var avaliableData = [];
                    userDeviceHistory.forEach((h) => {
                        if(userDetail.find((d) => d.sid == h.sid && `${h.app_id}_branch_id` in d  && d[`${h.app_id}_branch_id`] == selectedBranchId) ){
                            avaliableData.push(h)
                        }
                    })
                    setUsingDataTable(avaliableData);
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            });
    };

    const getPlayDDData = () => {
        setLoadingData(true);

        setPlayDDClassList([]);
        setPlayDDDeviceHost([]);
        setPlayDDDeviceClient([]);

        const playddCids = [];
        const playDDClassListNew = [];
        if (nurseryUser && nurseryUser.length > 0) {
            nurseryUser.forEach((s) => {
                if (s.role == "T" && s.playdd == "AP") {
                    playddCids.push(s.class_id);
                    playDDClassListNew.push({ id: s.class_id, name: s.class_name, userId: s.user_id, sid: s.sid, childContract: s.quantity, childRegist: 0 });
                }
            });
        }
        axios({
            method: "POST",
            url: `/api/playdd/subscriber/usage`,
            data: { nurseryUniqId: selectedNurseryId, classIdList: playddCids.join(",") },
        })
            .then((res) => {
                const result = res.data;
                if (playDDClassListNew && playDDClassListNew.length > 0) {
                    playDDClassListNew.forEach((c) => {
                        const l = result.classList.find((l) => l.classId == c.id);
                        if (l) {
                            c.childRegist = l.childRegist;
                            c.lastPlayDate = l.lastPlayDate;
                        }
                    });
                    setPlayDDClassList(playDDClassListNew);
                }
                sortByProperty(result.deviceHostList, "name");
                sortByProperty(result.deviceClientList, "name");

                setPlayDDDeviceHost(result.deviceHostList);
                setPlayDDDeviceClient(result.deviceClientList);
                setLoadingData(false);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                setLoadingData(false);
            });
    };

    const changePassword = (pw) => {
        axios({
            method: "PATCH",
            url: `/api/subscriber/${userId}/password/change`,
            data: { pwdNew: crypto.createHash("md5").update(pw.trim()).digest("hex") },
        })
            .then((res) => {
                alert("비밀번호가 변경되었습니다.");
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const changeTestType = (isTest) => {
        axios({
            method: "PATCH",
            url: `/api/subscriber/${userId}/test/change`,
            data: { isTest: isTest },
        })
            .then((res) => {
                alert("계정 타입이 변경되었습니다.");
                getNurseryData(selectedNurseryId);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const handleUpdateClassName = () => {
        let classNameNew = document.getElementById("newClassName").value;
        if (!classNameNew || classNameNew.trim().length < 2 || classNameNew.trim().length > 16) {
            // setUpdateResultMsg("반 이름은 4~16자내로 입력해 주세요.");
            toast.info("반 이름은 2~16자내로 입력해 주세요.");
            return;
        }

        axios({
            method: "patch",
            url: `/api/class/${userId}`,
            data: {
                name: classNameNew,
                oldName: userDetail.class_name,
            },
        })
            .then((res) => {
                alert("반 정보를 변경하였습니다.");
                getNurseryData(selectedNurseryId);
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const contractHistoryCallback = () => {
        if (userDetail != null && userDetail.is_555) {
            return;
        } else {
            axios({
                method: "get",
                url: `/api/contract/history/${nurseryInfo.branch_id}/${userId}`,
            })
                .then((res) => {
                    const data = res.data;
                    const result = {};
                    // const terminate = {};
                    let year_set = new Set();
                    // if (res.data.terminate) {
                    //     res.data.terminate.forEach((t) => (terminate[t.app_id] = t.terminate_date));
                    // }
                    for (let h of data.history) {
                        let year = Number(moment(h.start_date).format("MM")) >= 6 ? Number(moment(h.start_date).format("YYYY")) + 1 : Number(moment(h.start_date).format("YYYY"));
                        // let terminateDate = terminate[h.app_id]
                        //     ? moment(terminate[h.app_id]).isBetween(moment(h.start_date), moment(h.end_date), undefined, "[]")
                        //         ? terminate[h.app_id]
                        //         : false
                        //     : false;
                        result[`${h.app_id}_${year}`] = h;
                        // result[`${h.app_id}_${year}`].terminate = terminateDate;
                        year_set.add(year);
                    }

                    data.result = result;
                    data.years = Array.from(year_set);

                    setUserHistory(res.data);
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    };
    const updateMultiDevice = () => {
        let multiDeviceTomonote = document.getElementById("multiDeviceTomonote") ? document.getElementById("multiDeviceTomonote").value : 1;
        let multiDeviceMomo = document.getElementById("multiDeviceMomo") ? document.getElementById("multiDeviceMomo").value : 1;
        let multiDeviceJelliing = document.getElementById("multiDeviceJelliing") ? document.getElementById("multiDeviceJelliing").value : 1;
        let multiDeviceEnglish = document.getElementById("multiDeviceEnglish") ? document.getElementById("multiDeviceEnglish").value : 1;

        if (multiDeviceEnglish && multiDeviceMomo && multiDeviceTomonote) {
            axios({
                method: "PATCH",
                url: `/api/subscriber/${userId}/multi/device/change`,
                data: {
                    multiDeviceTomonote: multiDeviceTomonote,
                    multiDeviceMomo: multiDeviceMomo,
                    multiDeviceJelliing: multiDeviceJelliing,
                    multiDeviceEnglish: multiDeviceEnglish,
                },
            })
                .then((res) => {
                    alert("디바이스 설정이 변경되었습니다.");
                    getNurseryData(selectedNurseryId);
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    };

    const dicsonnectDevice = (params, rowIdx) => {
        if (window.confirm(`해당 디바이스와 [${params.app_name}]의 연결을 확인하고 해제하시겠습니까?`)) {
            axios({
                method: "delete",
                url: `/api/device/${params.app_id}`,
                data: {
                    id: params.id,
                    table: params.app_id,
                },
            })
                .then((res) => {
                    const response = res.data;
                    if (response.code == 200) {
                        if (response.data.disconnected > 0) {
                            if (params.app_id == "play-dd-host") {
                                let delUsingTableData = [...playddDeviceHost];
                                delUsingTableData.splice(rowIdx, 1);
                                setPlayDDDeviceHost(delUsingTableData);
                            } else if (params.app_id == "play-dd-client") {
                                let delUsingTableData = [...playddDeviceClient];
                                delUsingTableData.splice(rowIdx, 1);
                                setPlayDDDeviceClient(delUsingTableData);
                            } else {
                                let delUsingTableData = usingData.filter((e) => e.id != params.id);
                                console.log(delUsingTableData);
                                setUsingData(delUsingTableData);
                            }
                        }
                        alert(response.msg);
                    } else {
                        alert(response.msg);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    };

    let gridApi = null;

    let listColumn = [
        {
            headerName: "No.",
            headerClass: "bg-primary-light text-dark",
            children: [
                {
                    headerName: "",
                    headerClass: "bg-primary-light text-dark",
                    field: "sid",
                    sortable: false,
                    width: 70,
                    resizable: true,
                    filter: false,
                    valueGetter: `node.rowIndex + 1`,
                },
            ],
        },
        {
            headerName: "계정",
            headerClass: "bg-primary-light text-dark",
            bgcoloer:"white",
            children: [
                {
                    headerName: "",
                    headerClass: "bg-primary-light text-dark",
                    field: "user_id",
                    sortable: false,
                    minWidth: 80,
                    maxWidth: 140,
                    resizable: true,
                    filter: false,
                },
            ],
        },
        {
            headerName: "반 명",
            headerClass: "bg-primary-light text-dark",
            children: [
                {
                    headerName: "",
                    field: "class_name",
                    headerClass: "bg-primary-light text-dark",
                    sortable: false,
                    minWidth: 70,
                    maxWidth: 180,
                    resizable: true,
                    filter: false,
                    cellRenderer: (param) => {
                        if (param.data.role === "T") {
                            return param.data.class_name;
                        } else {
                            return "-";
                        }
                    },
                },
            ],
        },
        {
            headerName: "결합 상품",
            headerClass: "bg-primary-light text-dark",
            children: [
                {
                    headerName: "",
                    field: "class_name",
                    headerClass: "bg-primary-light text-dark",
                    sortable: false,
                    minWidth: 70,
                    maxWidth: 100,
                    resizable: true,
                    filter: false,
                    cellRenderer: (param) => {
                        if (param.data.unionInfo) {
                            return param.data.unionInfo.name;
                        } else {
                            return "-";
                        }
                    },
                },
            ],
        },
        {
            headerName: "토모노트",
            headerClass: "bg-tomonote",
            children: [
                {
                    headerName: "상태",
                    headerClass: "bg-tomonote",
                    field: "quantity",
                    sortable: false,
                    width: 90,
                    resizable: true,
                    filter: false,
                    cellClass: "text-center bg-tomonote-70",
                    cellStyle: param => {
                        if (param.data.tomonote != "AP" || param.data.role != "T" || (param.data.tomonote_branch_id != selectedBranchId && isRoleBranch)) {
                            return { backgroundColor: '#EAECEF'};
                        }
                        return null;
                    },
                    cellRenderer: (param) => {
                        if (param.data.role === "T") {
                            if (param.data.tomonote === "AP") {
                                if(param.data.tomonote_branch_id == selectedBranchId || !isRoleBranch){
                                    return "<font color='blue'>사용</font>";
                                } else {
                                    return "권한 없음"
                                }
                                
                            } else {
                                return "미사용";
                            }
                        } else {
                            return "-";
                        }
                    },
                },
                {
                    headerName: "연결기기",
                    headerClass: "bg-tomonote",
                    sortable: false,
                    width: 90,
                    resizable: true,
                    filter: false,
                    cellClass: "text-center bg-tomonote-70",
                    cellStyle: param => {
                        if (param.data.tomonote != "AP" || param.data.role != "T" || (param.data.tomonote_branch_id != selectedBranchId && isRoleBranch)) {
                            return { backgroundColor: '#EAECEF'};
                        }
                        return null;
                    },
                    cellRenderer: (param) => {
                        if (param.data.tomonote_device_cnt != null) {
                            if (param.data.tomonote != undefined) {
                                if(param.data.tomonote_branch_id == selectedBranchId || !isRoleBranch){
                                    return param.data.tomonote_device_cnt + "/" + param.data.multi_use_count_tomonote;
                                } else {
                                    return "권한 없음"
                                }
                            } else {
                                return "0/0";
                            }
                        }
                    },
                },
            ],
        },
        {
            headerName: "플레이딩동",
            headerClass: "bg-playdd",
            width: 100,
            resizable: true,
            filter: false,
            children: [
                {
                    headerName: "상태",
                    headerClass: "bg-playdd",
                    sortable: false,
                    width: 106,
                    resizable: true,
                    filter: false,
                    cellClass: "text-center  bg-playdd-70",
                    cellStyle: param => {
                        if (param.data.playdd != "AP" || param.data.role != "T" || (param.data.playdd_branch_id != selectedBranchId && isRoleBranch)) {
                            return { backgroundColor: '#EAECEF'};
                        }
                        return null;
                    },
                    cellRenderer: (param) => {
                        if (param.data.role === "T") {
                            if (param.data.playdd === "AP") {
                                if(param.data.playdd_branch_id == selectedBranchId || !isRoleBranch){
                                    return "<font color='blue'>사용</font>";
                                } else {
                                    return "권한 없음"
                                }
                            } else {
                                return "미사용";
                            }
                        } else {
                            return "-";
                        }
                    },
                },
            ],
        },
        {
            headerName: "모모한글수",
            headerClass: "bg-momo",
            children: [
                {
                    headerName: "상태",
                    headerClass: "bg-momo",
                    sortable: false,
                    width: 80,
                    resizable: true,
                    filter: false,
                    cellClass: "text-center  bg-momo-70",
                    cellStyle: param => {
                        if (param.data.momo != "AP" || param.data.role != "T" || (param.data.momo_branch_id != selectedBranchId && isRoleBranch)) {
                            return { backgroundColor: '#EAECEF'};
                        }
                        return null;
                    },
                    cellRenderer: (param) => {
                        if (param.data.role === "T") {
                            if (param.data.momo === "AP") {
                                if(param.data.momo_branch_id == selectedBranchId || !isRoleBranch){
                                    return "<font color='blue'>사용</font>";
                                } else {
                                    return "권한 없음"
                                }
                            } else {
                                return "미사용";
                            }
                        } else {
                            return "-";
                        }
                    },
                },
                {
                    headerName: "연결기기",
                    headerClass: "bg-momo",
                    sortable: false,
                    width: 90,
                    resizable: true,
                    filter: false,
                    cellClass: "text-center  bg-momo-70",
                    cellStyle: param => {
                        if (param.data.momo != "AP" || param.data.role != "T" || (param.data.momo_branch_id != selectedBranchId && isRoleBranch)) {
                            return { backgroundColor: '#EAECEF'};
                        }
                        return null;
                    },
                    cellRenderer: (param) => {
                        if (param.data.momo_device_cnt != null) {
                            if (param.data.momo != undefined) {
                                if(param.data.momo_branch_id == selectedBranchId || !isRoleBranch){
                                    return param.data.momo_device_cnt + "/" + param.data.multi_use_count_momo;
                                } else {
                                    return "권한 없음"
                                }
                            } else {
                                return "0/0";
                            }
                        }
                    },
                },
            ],
        },
        {
            headerName: "젤링",
            headerClass: "bg-jelliing",
            children: [
                {
                    headerName: "상태",
                    headerClass: "bg-jelliing",
                    sortable: false,
                    width: 80,
                    resizable: true,
                    filter: false,
                    cellClass: "text-center  bg-jelliing-70",
                    cellStyle: param => {
                        if (param.data.jelliing != "AP" || param.data.role != "T" || (param.data.jelliing_branch_id != selectedBranchId && isRoleBranch)) {
                            return { backgroundColor: '#EAECEF'};
                        }
                        return null;
                    },
                    cellRenderer: (param) => {
                        if (param.data.role === "T") {
                            if (param.data.jelliing === "AP") {
                                if(param.data.jelliing_branch_id == selectedBranchId || !isRoleBranch){
                                    return "<font color='blue'>사용</font>";
                                } else {
                                    return "권한 없음"
                                }
                            } else {
                                return "미사용";
                            }
                        } else {
                            return "-";
                        }
                    },
                },
                {
                    headerName: "연결기기",
                    headerClass: "bg-jelliing",
                    sortable: false,
                    width: 90,
                    resizable: true,
                    filter: false,
                    cellClass: "text-center  bg-jelliing-70",
                    cellStyle: param => {
                        if (param.data.jelliing != "AP" || param.data.role != "T" || (param.data.jelliing_branch_id != selectedBranchId && isRoleBranch)) {
                            return { backgroundColor: '#EAECEF'};
                        }
                        return null;
                    },
                    cellRenderer: (param) => {
                        if (param.data.jelliing_device_cnt != null) {
                            if (param.data.jelliing != undefined) {
                                if(param.data.jelliing_branch_id == selectedBranchId || !isRoleBranch){
                                    return param.data.jelliing_device_cnt + "/" + param.data.multi_use_count_jelliing;
                                } else {
                                    return "권한 없음"
                                }
                            } else {
                                return "0/0";
                            }
                        }
                    },
                },
            ],
        },

        {
            headerName: "플라잉클래스",
            headerClass: "bg-tomoenglish",
            children: [
                {
                    headerName: "상태",
                    headerClass: "bg-tomoenglish",
                    sortable: false,
                    width: 80,
                    resizable: true,
                    filter: false,
                    cellClass: "text-center  bg-tomoenglish-70",
                    cellStyle: param => {
                        if (param.data.tomoenglish != "AP" || param.data.role != "T" || (param.data.tomoenglish_branch_id != selectedBranchId && isRoleBranch)) {
                            return { backgroundColor: '#EAECEF'};
                        }
                        return null;
                    },
                    cellRenderer: (param) => {
                        if (param.data.role === "T") {
                            if (param.data.tomoenglish === "AP") {
                                if(param.data.tomoenglish_branch_id == selectedBranchId || !isRoleBranch){
                                    return "<font color='blue'>사용</font>";
                                } else {
                                    return "권한 없음"
                                }
                            } else {
                                return "미사용";
                            }
                        } else {
                            return "-";
                        }
                    },
                },
                {
                    headerName: "연결기기",
                    headerClass: "bg-tomoenglish",
                    sortable: false,
                    width: 90,
                    resizable: true,
                    filter: false,
                    cellClass: "text-center  bg-tomoenglish-70",
                    cellStyle: param => {
                        if (param.data.tomoenglish != "AP" || param.data.role != "T" || (param.data.tomoenglish_branch_id != selectedBranchId && isRoleBranch)) {
                            return { backgroundColor: '#EAECEF'};
                        }
                        return null;
                    },
                    cellRenderer: (param) => {
                        if (param.data.tomoenglish_device_cnt != null) {
                            if (param.data.tomoenglish != undefined) {
                                if(param.data.tomoenglish_branch_id == selectedBranchId || !isRoleBranch){
                                    return param.data.tomoenglish_device_cnt + "/" + param.data.multi_use_count_tomoenglish;
                                } else {
                                    return "권한 없음"
                                }
                            } else {
                                return "0/0";
                            }
                        }
                    },
                },
            ],
        },
        {
            headerName: "별별책방",
            headerClass: "bg-tomobooks",
            children: [
                {
                    headerName: "상태",
                    headerClass: "bg-tomobooks",
                    sortable: false,
                    width: 80,
                    resizable: true,
                    filter: false,
                    cellClass: "text-center  bg-tomobooks-70",
                    cellStyle: param => {
                        if (param.data.tomobooks != "AP" || param.data.role != "T" || (isRoleBranch && param.data.tomobooks_branch_id != selectedBranchId )) {
                            return { backgroundColor: '#EAECEF'};
                        }
                        return null;
                    },
                    cellRenderer: (param) => {
                        if (param.data.role === "T") {
                            if (param.data.tomobooks === "AP") {
                                if(param.data.tomobooks_branch_id == selectedBranchId || !isRoleBranch){
                                    return "<font color='blue'>사용</font>";
                                } else {
                                    return "권한 없음"
                                }
                            } else {
                                return "미사용";
                            }
                        } else {
                            return "-";
                        }
                    },
                },
                {
                    headerName: "연결기기",
                    headerClass: "bg-tomobooks",
                    sortable: false,
                    width: 90,
                    resizable: true,
                    filter: false,
                    cellClass: "text-center  bg-tomobooks-70",
                    cellStyle: param => {
                        if (param.data.tomobooks != "AP" || param.data.role != "T" || (isRoleBranch && param.data.tomobooks_branch_id != selectedBranchId )) {
                            return { backgroundColor: '#EAECEF'};
                        }
                        return null;
                    },
                    cellRenderer: (param) => {
                        if (param.data.tomobooks_device_cnt != null) {
                            if (param.data.tomobooks != undefined) {
                                if(param.data.tomobooks_branch_id == selectedBranchId || !isRoleBranch){
                                    return param.data.tomobooks_device_cnt + "/" + param.data.multi_use_count_tomobooks;
                                } else {
                                    return "권한 없음"
                                }
                            } else {
                                return "0/0";
                            }
                        }
                    },
                },
            ],
        },
        {
            headerName: "상세정보",
            headerClass: "bg-primary-light text-dark",
            children: [
                {
                    headerName: "",
                    colId: "mngr",
                    headerClass: "bg-primary-light text-dark",
                    sortable: false,
                    width: 90,
                    resizable: true,
                    filter: false,
                    cellRenderer: (params) => {
                        return '<button class="btn btn-primary btn-sm font-12" style="padding: 1px 3px">관리</button>';
                    },
                },
            ],
        },
    ];

    let listColumnUsing = [
        {
            headerName: "No.",
            headerClass: "bg-primary-light text-dark",
            field: "no",
            sortable: false,
            width: 35,
            resizable: true,
            filter: false,
            valueGetter: `node.rowIndex + 1`,
        },
        {
            headerName: "앱명",
            headerClass: "bg-primary-light text-dark",
            field: "app_name",
            sortable: true,
            width: 70,
            resizable: true,
            filter: false,
        },
        {
            headerName: "앱 버전",
            headerClass: "bg-primary-light text-dark",
            field: "version",
            sortable: true,
            width: 50,
            resizable: true,
            filter: false,
        },
        {
            headerName: "계정",
            headerClass: "bg-primary-light text-dark",
            field: "user_id",
            sortable: true,
            width: 70,
            resizable: true,
            filter: false,
        },
        {
            headerName: "반 명",
            headerClass: "bg-primary-light text-dark",
            field: "class_name",
            sortable: true,
            width: 80,
            resizable: true,
            filter: false,
        },
        {
            headerName: "DID",
            headerClass: "bg-primary-light text-dark",
            field: "did",
            sortable: true,
            width: 100,
            resizable: true,
            filter: false,
        },
        {
            headerName: "모델명",
            headerClass: "bg-primary-light text-dark",
            field: "device_model",
            sortable: true,
            width: 70,
            resizable: true,
            filter: false,
            cellRenderer: (param) => {
                if (param.data.device_model != null) {
                    return param.data.device_model;
                } else {
                    return "-";
                }
            },
        },
        {
            headerName: "계약 기간",
            headerClass: "bg-primary-light text-dark",
            field: "user_id",
            sortable: true,
            width: 120,
            resizable: true,
            filter: false,
            cellRenderer: (param) => {
                if (param.data.start_date != null && param.data.end_date != null) {
                    return param.data.start_date + "~" + param.data.end_date;
                } else {
                    return "-";
                }
            },
        },
        {
            headerName: "연결해제",
            headerClass: "bg-primary-light text-dark text-center",
            colId: "disconnect",
            field: "disconnect",
            maxWidth: 80,
            width: 80,
            filter: false,
            sortable: false,
            resizable: true,
            cellRenderer: (param) => {
                return `<button class='btn btn-danger ' style='padding: 2px 14px'>해제</button>`;
            },
        },
        {
            headerName: "최근 접속일",
            headerClass: "bg-primary-light text-dark",
            field: "last_access",
            sortable: true,
            width: 100,
            resizable: true,
            filter: false,
        },
    ];

    const defaultColDef = {
        headerClass: "bg-primary-light text-dark",
        cellClass: "text-center",
        minWidth: 70,
        width: 70,
        sortable: false,
        resizable: true,
        filter: false,
    };

    let listColumnPlayDDClass = [
        {
            headerName: "No.",
            field: "no",
            maxWidth: 55,
            valueGetter: `node.rowIndex + 1`,
        },
        {
            headerName: "계정",
            field: "userId",
            sortable: true,
        },
        {
            headerName: "반 이름",
            field: "name",
            width: 150,
            sortable: true,
        },
        {
            headerName: "계약 원아수",
            field: "childContract",
            width: 100,
            sortable: true,
        },
        {
            headerName: "등록 원아수",
            field: "childRegist",
            width: 100,
            sortable: true,
        },
        {
            headerName: "최근 수업 일시",
            field: "lastPlayDate",
            width: 120,
            sortable: true,
        },
    ];

    let listColumnPlayDDDeviceHost = [
        {
            headerName: "No.",
            field: "no",
            maxWidth: 55,
            valueGetter: `node.rowIndex + 1`,
        },
        {
            headerName: "전자칠판 이름",
            field: "name",
            sortable: true,
        },
        {
            headerName: "디바이스ID",
            field: "did",
            width: 150,
            sortable: true,
            cellClass: "text-center",
            cellRenderer: (param) => {
                let cell = param.value;
                if(param.data.useClassId) {
                    cell += `<span class="badge badge-success ml-2">사용중</span>`;
                }
                return cell;
            },
        },
        {
            headerName: "모델명",
            field: "deviceModel",
            width: 120,
            sortable: true,
        },
        {
            headerName: "버전",
            field: "version",
            maxWidth: 120,
            width: 120,
            sortable: true,
        },
        {
            headerName: "최초 등록 일시",
            field: "createDate",
            maxWidth: 180,
            width: 180,
            sortable: true,
        },
        {
            headerName: "최종 사용 일시",
            field: "lastAccess",
            maxWidth: 180,
            width: 180,
            sortable: true,
        },
        {
            headerName: "연결 해제",
            colId: "disconnect",
            field: "disconnect",
            maxWidth: 80,
            width: 80,
            filter: false,
            resizable: false,
            cellRenderer: (param) => {
                return `<button class='btn btn-danger' style='padding: 2px 14px'>해제</button>`;
            },
        },
    ];
    let listColumnPlayDDDeviceClient = [
        {
            headerName: "No.",
            field: "no",
            maxWidth: 55,
            valueGetter: `node.rowIndex + 1`,
        },
        {
            headerName: "태블릿 이름",
            field: "name",
            sortable: true,
        },
        {
            headerName: "디바이스ID",
            field: "did",
            width: 150,
            sortable: true,
        },
        {
            headerName: "모델명",
            field: "deviceModel",
            width: 120,
            sortable: true,
        },
        {
            headerName: "버전",
            field: "version",
            maxWidth: 120,
            width: 120,
            sortable: true,
        },
        {
            headerName: "최초 등록 일시",
            field: "createDate",
            maxWidth: 180,
            width: 180,
            sortable: true,
        },
        {
            headerName: "최종 사용 일시",
            field: "lastAccess",
            maxWidth: 180,
            width: 180,
            sortable: true,
        },
        {
            headerName: "연결 해제",
            colId: "disconnect",
            field: "disconnect",
            maxWidth: 80,
            width: 80,
            filter: false,
            resizable: false,
            cellRenderer: (param) => {
                return `<button class='btn btn-danger' style='padding: 2px 14px'>해제</button>`;
            },
        },
    ];

    const onRowClicked = (params) => {
        if (params.api.getFocusedCell().column.getColId() === "mngr") {
            onManage(params.data.sid);
        }

        if (params.api.getFocusedCell().column.getColId() === "disconnect") {
            dicsonnectDevice(params.data, params.rowIndex);
        }
    };

    const onManage = (id) => {
        setUserId(id);
        setShow(true);
    };

    const handleKeyPress1 = (e) => {
        if (e.key === "Enter") {
            searchUsingData();
        }
    };

    const searchUsingData = () => {
        let searchTableData =
            usingData != null
                ? usingData.filter((u) => (u.user_id.includes(subKeyword) || u.did.includes(subKeyword) || subKeyword == null) && (u.app_id === subSearchApp || subSearchApp == "all"))
                : usingData;
        setUsingDataTable(searchTableData);
    };

    const handleKeyPress2 = (e) => {
        if (e.key === "Enter") {
            searchUserData();
        }
    };

    const searchUserData = () => {
        let searchTableData =
            nurseryUser != null
                ? nurseryUser.filter((u) => (u.user_id.includes(subKeyword2) || subKeyword2 == null))
                : nurseryUser;
        setNurseryUserTable(searchTableData);
    }

    const searchDataByApp = (e) => {
        setSubSearchApp(e.target.value);
    };

    const findUser = (id) => {
        if (nurseryUser != null) {
            let user = nurseryUser.find((u) => u.sid == id);
            setUserDetail(user);
        }
    };

    const onGridReady = (params) => {
        gridApi = params.api;
        params.api.sizeColumnsToFit();
    };

    const checkPassword = () => {
        let newPW = document.getElementById("newPassword").value;
        let chkPW = document.getElementById("chkPassword").value;
        if (!newPW || newPW.trim().length < 4 || newPW.trim().length > 16) {
            alert("비밀번호는 4~16자내로 입력해 주세요.");
            return;
        }
        if (newPW != null && newPW === chkPW) {
            changePassword(chkPW);
        } else {
            alert("비밀번호가 일치하지 않습니다");
        }
    };

    const changeType = () => {
        let chgType = document.getElementById("selectType").value;
        changeTestType(chgType);
    };

    return (
        <div>
            {nurseryInfo == null ? (
                <div style={{ height: 100 + "px", textAlign: "center", paddingTop: `${100 / 2 - 80}px` }}>
                    <span className="dashboard-spinner spinner-xxl"></span>
                </div>
            ) : (
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <th className="bg-dark text-light" style={{ width: "15%" }}>
                                        원명
                                    </th>
                                    <td className="form-control placeholder-clear-on-focus">{nurseryInfo.name}</td>
                                    <th className="bg-dark text-light">원 유형</th>
                                    <td className="form-control placeholder-clear-on-focus">{nurseryInfo.type == "S" ? "유치원" : nurseryInfo.type == "A" ? "어린이집" : "기타"}</td>
                                </tr>
                                <tr>
                                    <th className="bg-dark text-light"> 원 주소</th>
                                    <td className="form-control placeholder-clear-on-focus">{nurseryInfo.address} </td>
                                    <th className="bg-dark text-light">원장명</th>
                                    <td className="form-control placeholder-clear-on-focus">{nurseryInfo.director}</td>
                                </tr>
                                <tr>
                                    <th className="bg-dark text-light">원 전화번호</th>
                                    <td className="form-control placeholder-clear-on-focus" colSpan={loginBranchInfo ? 3 : 1}>
                                        {nurseryInfo.tel}
                                    </td>
                                    {!loginBranchInfo && (
                                        <>
                                            <th className="bg-dark text-light">계약 지사</th>
                                            <td className="form-control placeholder-clear-on-focus">{nurseryBranch && nurseryBranch.map((b) => b.branch_name).join(" / ")}</td>
                                        </>
                                    )}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            <div className="row" style={{ marginTop: "10px" }}>
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <th className="bg-dark text-light">계정별 서비스 이용 현황</th>
                            </tr>
                            <tr>
                                <th className="form-control placeholder-clear-on-focus" style={{ height: "60px" }}>
                                    <input type="submit" style={{ float: "right", height: "40px" }} className="btn btn-primary" value="검색" onClick={searchUsingData} />

                                    <input
                                        style={{ float: "right", width: "270px", height: "40px" }}
                                        type="text"
                                        id="keyword"
                                        placeholder="계정"
                                        onChange={(e) => setSubKeyword2(e.target.value)}
                                        onKeyPress={handleKeyPress2}
                                    />
                                </th>
                            </tr>
                            <tr>
                                <td style={{ margin: "0px", width: "100%" }}>
                                    <AgGridReactEx
                                        background-color="white"
                                        columnDefs={listColumn}
                                        rowData={nurseryUserTable}
                                        height={nurseryUserTable != null && nurseryUserTable.length > 2 ? 350 : 200}
                                        enableCellTextSelection={true}
                                        onRowClicked={onRowClicked}
                                        onGridReady={onGridReady}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <Modal
                className={`modal-contract modal-container fullscreen-modal`}
                show={show}
                onHide={() => {
                    setShow(false);
                    // if (window.confirm("상세 정보 수정을 취소하시겠습니까?")) {
                    //     setShow(false);
                    //     // document.location.reload();
                    // }
                }}
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title font-14">계정 상세 정보</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <div className="row m-0">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <table className="table table-bordered">
                                <tr>
                                    <th className="bg-dark text-light" style={{ width: "20%" }}>
                                        계정
                                    </th>
                                    <td className="form-control placeholder-clear-on-focus">{userDetail != null && userDetail.user_id != null ? userDetail.user_id : "-"}</td>
                                    <th className="bg-dark text-light" style={{ width: "20%" }}>
                                        {!loginBranchInfo && "계정 타입"}
                                    </th>
                                    <td className="form-control placeholder-clear-on-focus">
                                        {!loginBranchInfo ? (
                                            <select id="selectType" onChange={changeType} style={{ width: "150px" }}>
                                                <option value={0} selected={userDetail != null && (userDetail.is_test == null || userDetail.is_test == 0)}>
                                                    일반계정
                                                </option>
                                                <option value={1} selected={userDetail != null && userDetail.is_test == 1}>
                                                    테스트 계정
                                                </option>
                                            </select>
                                        ) : (
                                            <div> &nbsp;</div>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th className="bg-dark text-light">반 명</th>
                                    <td className="form-control placeholder-clear-on-focus">
                                        {userDetail != null && userDetail.role != "D" ? (
                                            <input type="text" key={userDetail.class_name} id="newClassName" defaultValue={userDetail != null && userDetail.class_name != null ? userDetail.class_name : "-"} />
                                        ) : (
                                            "-"
                                        )}
                                        &nbsp;
                                        {userDetail != null && userDetail.role == "D" ? (
                                            ""
                                        ) : (
                                            <button class="btn btn-sm btn-primary btn-rounded" onClick={handleUpdateClassName}>
                                                저장
                                            </button>
                                        )}
                                    </td>
                                    <th className="bg-dark text-light">최초 등록일</th>
                                    <td className="form-control placeholder-clear-on-focus">{userDetail != null && userDetail.create_date != null ? userDetail.create_date : "-"}</td>
                                </tr>
                                <tr>
                                    <th className="bg-dark text-light">등록 원아 수</th>
                                    <td className="form-control placeholder-clear-on-focus">{userDetail != null && userDetail.quantity != null ? userDetail.quantity + "명" : "-"}</td>
                                    <th className="bg-dark text-light">디바이스 선택 </th>
                                    <td className="form-control placeholder-clear-on-focus">
                                        {userDetail != null && userDetail.device != null ? (userDetail.device == "board" ? "전자칠판" : "태블릿") : "-"}
                                    </td>
                                </tr>
                                <tr>
                                    <th className="bg-dark text-light">비밀번호 변경</th>
                                    <td colSpan={3}>
                                        <table>
                                            <tr>
                                                <td> 새로운 비밀번호</td>
                                                <td>
                                                    <input type="password" id="newPassword" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>비밀번호 확인</td>
                                                <td>
                                                    <input type="password" id="chkPassword" /> &nbsp;
                                                    <button class="btn btn-sm btn-primary btn-rounded" onClick={checkPassword}>
                                                        저장
                                                    </button>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th className="bg-dark text-light">계약 히스토리</th>
                                    <td colSpan={3}>
                                        <table className="table table-bordered">
                                            {serviceAppList.map((a) => {
                                                if(a.contractUseTas) {
                                                    return (
                                                        <th className={`bg-${a.key} text-center text-light`} style={{ width: "17%" }}>
                                                            {a.name}
                                                        </th>
                                                    );
                                                }
                                            })}
                                            {userHistory != null &&
                                                userHistory.years.map((y, idx) => {
                                                    return (
                                                        <tr key={`table-contract-history-${idx}`}>
                                                            {serviceAppList.map((a) => {
                                                                if(a.contractUseTas) {
                                                                    if (userDetail[`${a.key}_branch_id`] != selectedBranchId && userDetail[`${a.key}`] == "AP"){
                                                                        return <td className="text-center" style={{backgroundColor: "#EAECEF"}}>권한없음</td>
                                                                    }
                                                                    else {
                                                                        return (
                                                                            <td className="text-center">
                                                                                {userHistory.result[`${a.key}_` + y]
                                                                                    ? `${userHistory.result[`${a.key}_` + y].start_date} ~ ${userHistory.result[`${a.key}_` + y].end_date}` : `-`}
                                                                                {userHistory.result[`${a.key}_` + y] && userHistory.result[`${a.key}_` + y].terminate && (
                                                                                    <>
                                                                                        <br />
                                                                                        <span className="text-danger">{`(${userHistory.result[`${a.key}_` + y].terminate} 해지)`}</span>
                                                                                    </>
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    } 
                                                                }
                                                            })}
                                                        </tr>
                                                    );
                                                })}

                                            {userHistory != null && (!userHistory.years || userHistory.years.length === 0) && (
                                                <tr>
                                                    <td colSpan="4" className="text-center font-bold">
                                                        해당 계약에 입력된 히스토리가 존재하지 않습니다.
                                                    </td>
                                                </tr>
                                            )}
                                        </table>
                                    </td>
                                </tr>
                                {!loginBranchInfo && (
                                    <tr>
                                        <th className="bg-dark text-light">멀티 디바이스 설정</th>
                                        <td colSpan={3}>
                                            <table className="table table-bordered">
                                                <tr>
                                                    {serviceAppList.map((a) => {
                                                        if(a.contractUseTas) {
                                                            return (
                                                                <th className={`bg-${a.key} text-center text-light`} style={{ width: "17%" }}>
                                                                    {a.name}
                                                                </th>
                                                            );
                                                        }
                                                    })}
                                                    <th className="bg-dark text-center text-light"></th>
                                                </tr>
                                                <tr>
                                                    <td align="center">
                                                        {userDetail != null && userDetail.tomonote == "AP" ? (
                                                            <input
                                                                type="text"
                                                                id="multiDeviceTomonote"
                                                                textAlign="center"
                                                                style={{ width: "60px", height: "35px" }}
                                                                defaultValue={userDetail != null && userDetail.multi_use_count_tomonote != null ? userDetail.multi_use_count_tomonote : 1}
                                                            />
                                                        ) : (
                                                            "미사용"
                                                        )}
                                                    </td>
                                                    <td align="center">{userDetail != null && userDetail.multi_use_count_playdd != null ? userDetail.multi_use_count_playdd : "-"}</td>
                                                    <td align="center">
                                                        {userDetail != null && userDetail.momo == "AP" ? (
                                                            <input
                                                                type="text"
                                                                id="multiDeviceMomo"
                                                                textAlign="center"
                                                                style={{ width: "60px", height: "35px" }}
                                                                defaultValue={userDetail != null && userDetail.multi_use_count_momo != null ? userDetail.multi_use_count_momo : 1}
                                                            />
                                                        ) : (
                                                            "미사용"
                                                        )}
                                                    </td>

                                                    <td align="center">
                                                        {userDetail != null && userDetail.jelliing == "AP" ? (
                                                            <input
                                                                type="text"
                                                                id="multiDeviceJelliing"
                                                                textAlign="center"
                                                                style={{ width: "60px", height: "35px" }}
                                                                defaultValue={userDetail != null && userDetail.multi_use_count_jelliing != null ? userDetail.multi_use_count_jelliing : 1}
                                                            />
                                                        ) : (
                                                            "미사용"
                                                        )}
                                                    </td>

                                                    <td align="center">{userDetail != null && userDetail.multi_use_count_tomobooks != null ? userDetail.multi_use_count_tomobooks : "-"}</td>

                                                    <td align="center">
                                                        {userDetail != null && userDetail.tomoenglish == "AP" ? (
                                                            <input
                                                                type="text"
                                                                id="multiDeviceEnglish"
                                                                textAlign="center"
                                                                style={{ width: "60px", height: "35px" }}
                                                                defaultValue={userDetail != null && userDetail.multi_use_count_tomoenglish != null ? userDetail.multi_use_count_tomoenglish : 1}
                                                            />
                                                        ) : (
                                                            "미사용"
                                                        )}
                                                    </td>
                                                    <td align="center">
                                                        <button class="btn btn-sm btn-primary btn-rounded" onClick={updateMultiDevice}>
                                                            저장
                                                        </button>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                )}
                            </table>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <div className="row" style={{ marginTop: "10px" }}>
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <th className="bg-dark text-light">앱 별 사용 정보(플레이 딩동 외)</th>
                            </tr>
                            <tr>
                                <th className="form-control placeholder-clear-on-focus" style={{ height: "60px" }}>
                                    <input type="radio" name="selectUsingApp" id="radio-app-all" value="all" style={{ display: "inline-block", marginLeft: "20px" }} onChange={searchDataByApp} defaultChecked />
                                    <label htmlFor="radio-app-all" style={{ marginTop: "12px", marginRight: "20px" }}>
                                        &nbsp;전체
                                    </label>
                                    {serviceAppList.map((a) => {
                                        if(a.contractUseTas && a.key != 'playdd') {
                                            return (
                                                <>
                                                    <input type="radio" name="selectUsingApp" id={`radio-app-${a.key}`} value={a.key} style={{ display: "inline-block" }} onChange={searchDataByApp} />
                                                    <label htmlFor={`radio-app-${a.key}`} style={{ marginTop: "12px", marginRight: "20px" }}>
                                                        &nbsp;{a.name}
                                                    </label>
                                                </>
                                            );
                                        }
                                    })}
                                    <input type="submit" style={{ float: "right", height: "40px" }} className="btn btn-primary" value="검색" onClick={searchUsingData} />
                                    <input
                                        style={{ float: "right", width: "270px", height: "40px" }}
                                        type="text"
                                        id="keyword"
                                        placeholder="계정 | DID"
                                        onChange={(e) => setSubKeyword(e.target.value)}
                                        onKeyPress={handleKeyPress1}
                                    />
                                </th>
                            </tr>
                            <tr>
                                <td style={{ margin: "0px", width: "100%" }}>
                                    <AgGridReactEx
                                        columnDefs={listColumnUsing}
                                        rowData={UsingDataTable}
                                        height={UsingDataTable != null && UsingDataTable.length > 2 ? 350 : 200}
                                        enableCellTextSelection={true}
                                        onRowClicked={onRowClicked}
                                        onGridReady={onGridReady}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row" style={{ marginTop: "10px" }}>
                <div className="col">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <th className="bg-dark text-light">플레이 딩동 사용 정보</th>
                            </tr>
                            <th>
                                <div className="h6 mb-0">&lt;반 정보&gt;</div>
                            </th>
                            <tr>
                                <td style={{ paddingTop: "0px" }}>
                                    <div className="row">
                                        <div className="col" style={{ marginTop: "0px" }}>
                                            <AgGridReactEx
                                                defaultColDef={defaultColDef}
                                                columnDefs={listColumnPlayDDClass}
                                                rowData={playddClassList}
                                                height={300}
                                                enableCellTextSelection={true}
                                                onRowClicked={onRowClicked}
                                                onGridReady={onGridReady}
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <th>
                                <div className="h6 mb-0">&lt;전자칠판 정보&gt;</div>
                            </th>
                            <tr>
                                <td style={{ paddingTop: "0px" }}>
                                    <div className="row">
                                        <div className="col">
                                            <AgGridReactEx
                                                defaultColDef={defaultColDef}
                                                columnDefs={listColumnPlayDDDeviceHost}
                                                rowData={playddDeviceHost}
                                                height={300}
                                                enableCellTextSelection={true}
                                                onRowClicked={onRowClicked}
                                                onGridReady={onGridReady}
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <th>
                                <div className="h6 mb-0">&lt;태블릿 정보&gt;</div>
                            </th>
                            <tr>
                                <td style={{ paddingTop: "0px" }}>
                                    <div className="row">
                                        <div className="col">
                                            <AgGridReactEx
                                                defaultColDef={defaultColDef}
                                                columnDefs={listColumnPlayDDDeviceClient}
                                                rowData={playddDeviceClient}
                                                height={400}
                                                enableCellTextSelection={true}
                                                onRowClicked={onRowClicked}
                                                onGridReady={onGridReady}
                                            />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default NurseryDetail;
